import { objectEntries } from "@gss/common/objectUtil";
import type { StringRecord } from "@gss/types/StringRecord";

interface Module {
    default: string;
}

const modules = {
    highcharts: import.meta.glob<Module>("@resources/highcharts/*", {
        eager: true,
        query: "url",
    }),
    icons: import.meta.glob<Module>("@resources/icons/*", {
        eager: true,
        query: "url",
    }),
};

function parseModules(
    modules: Record<string, Module>,
    prefixOrigin: boolean,
): StringRecord<string> {
    const result: StringRecord<string> = {};

    for (const [key, module] of objectEntries(modules)) {
        let name = key.split("/").pop();

        if (name == null) {
            throw new Error(`Failed to extract resource name from key: ${key}`);
        }

        const index = name.indexOf(".");

        if (index !== -1) {
            name = name.slice(0, index);
        }

        result[name] = prefixOrigin
            ? location.origin + module.default
            : module.default;
    }

    return result;
}

const dimensionIcons = parseModules(modules.icons, true);
const highchartsConfig = parseModules(modules.highcharts, false);

export function getDimensionIconUrl(name: string): string {
    if (dimensionIcons[name] != null) {
        return dimensionIcons[name];
    }
    throw new Error(`Dimension icon not found: ${name}`);
}

export function getHighchartsConfig(name: string): string {
    if (highchartsConfig[name] != null) {
        return highchartsConfig[name];
    }
    throw new Error(`Highcharts config not found: ${name}`);
}
